import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ExportModal from './exportmodal';
import logger from '../logger';
import { useAuth } from './authcontext';
import './sidebar.css';

const Sidebar = ({ isOpen, onToggle }) => {
  const location = useLocation();
  const [showExportModal, setShowExportModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();
  const { logout } = useAuth();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleExport = (dataTypes, format, subOptions) => {
    logger.debug('Exporting', dataTypes, 'in', format, 'with sub-options', subOptions);
    // Simulate export process
    const content = 'Sample export data';
    const blob = new Blob([content], { type: format === 'csv' ? 'text/csv' : format === 'json' ? 'application/json' : 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `export.${format}`;
    a.click();
    URL.revokeObjectURL(url);
    setSuccessMessage(`Successfully exported ${dataTypes.join(', ')} in ${format.toUpperCase()} format.`);
    setTimeout(() => setSuccessMessage(''), 3000);
  };
  const handleLogout = () => {
    logout();
    localStorage.removeItem('staffId');
    navigate('/login');
  };

  return (
    <>
      <nav className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
        <div className="logo">
          <button
            className="toggle-button"
            onClick={onToggle} // Fixed: Changed from isActive to onToggle
            aria-label={isOpen ? 'Close sidebar' : 'Open sidebar'}
          >
            <svg
              className="toggle-icon"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#F77600"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
          <div className="logo-text">
            <span className="logo-main">EnRiCH</span>
          </div>
        </div>
        {successMessage && (
          <div className="success-message">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="success-icon">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
            </svg>
            {successMessage}
          </div>
        )}
        <ul>
          <li className={isActive('/') || isActive('/dashboard') ? 'active' : ''}>
            <Link to="/dashboard" className="nav-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
              </svg>
              Dashboard
            </Link>
          </li>
          <li className={isActive('/courses') ? 'active' : ''}>
            <Link to="/courses" className="nav-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
              Courses
            </Link>
          </li>
          <li className={isActive('/quiz') ? 'active' : ''}>
            <Link to="/quiz" className="nav-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z" />
              </svg>
              Quiz & Certification
            </Link>
          </li>
          <li className={isActive('/analytics') ? 'active' : ''}>
            <Link to="/analytics" className="nav-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" />
              </svg>
              Analytics
            </Link>
          </li>
          <li className={isActive('/user-management') ? 'active' : ''}>
            <Link to="/user-management" className="nav-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H17c-.8 0-1.54.37-2.01 1l-1.74 1.96c-.34.41-.54.93-.54 1.48V18h-2v-6c0-1.1.45-2.11 1.17-2.83L15 7.83c.39-.39.9-.59 1.41-.59h2.12c.72 0 1.39.35 1.81.94L21.5 16H19v6h1z" />
              </svg>
              User Management
            </Link>
          </li>
          <li className={isActive('/content') ? 'active' : ''}>
            <Link to="/content" className="nav-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8V4h6v4h4v10z" />
              </svg>
              Content
            </Link>
          </li>
          <li className={isActive('/blog') ? 'active' : ''}>
            <Link to="/blog" className="nav-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M4 4h16v2H4V4zm0 5h16v11H4V9zm2 2v7h5v-7H6zm7 0v2h5v-2h-5zm0 4v2h5v-2h-5z" />
              </svg>
              Blog
            </Link>
          </li>
          <li className={isActive('/feedback') ? 'active' : ''}>
            <Link to="/feedback" className="nav-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 2H4c-1.1 0-2 .9-2 2v14l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 9H6V9h12v2zm0-3H6V6h12v2z" />
              </svg>
              Feedback
            </Link>
          </li>
          <li className={isActive('/forum') ? 'active' : ''}>
            <Link to="/forum" className="nav-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 2H4c-1.1 0-2 .9-2 2v14l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 9H6V9h12v2zm0-3H6V6h12v2z" />
              </svg>
              Forum
            </Link>
          </li>
          <li className={isActive('/monitor') ? 'active' : ''}>
            <Link to="/monitor" className="nav-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z" />
              </svg>
              Monitor
            </Link>
          </li>
          <li className={isActive('/ask-vik') ? 'active' : ''}>
            <Link to="/ask-vik" className="nav-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                <circle cx="9" cy="9" r="1.5"/>
                <circle cx="15" cy="9" r="1.5"/>
                <path d="M9 15h6"/>
                <path d="M12 3v3"/>
                <path d="M12 18v3"/>
                <path d="M3 12h3"/>
                <path d="M18 12h3"/>
              </svg>
              EnRiCH DLP Assistant
            </Link>
          </li>
          <li className={isActive('/export-data') ? 'active' : ''}>
            <button
              className="nav-link export-data-link"
              onClick={() => setShowExportModal(true)}
              aria-label="Export system data"
              title="Export system data"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 13H5v-2h14v2zm-6 6H5v-2h8v2zm6-10H5V7h14v2zM3 5V3h18v2H3zm0 14v2h18v-2H3z" />
              </svg>
              Export Data
            </button>
          </li>
          <li className={isActive('/settings') ? 'active' : ''}>
            <Link to="/settings" className="nav-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />
              </svg>
              Settings
            </Link>
          </li>
          <li>
            <button
              className="nav-link export-data-link"
              onClick={handleLogout}
              aria-label="Log out"
              title="Log out"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
              </svg>
              Logout
            </button>
          </li>
        </ul>
      </nav>

      <button
        className={`sidebar-toggle logo-toggle ${isOpen ? 'open' : ''}`}
        onClick={onToggle}
        aria-label="Toggle Sidebar"
        type="button"
      >
        <svg
          className="sidebar-logo-icon"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#F77600"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      <ExportModal
        isOpen={showExportModal}
        onClose={() => setShowExportModal(false)}
        onExport={handleExport}
        context={null}
      />
    </>
  );
};

export default Sidebar;